import { Box, Flex, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LEGAL_HISTORY } from "../../utils/legalDate";

// Pod nagłówkiem dokumentu prawnego: baner wersji archiwalnej albo link do poprzednich wersji
const LegalVersionNote = ({ doc, archivedVersion }) => {
    const { i18n } = useTranslation();
    const en = i18n.language?.startsWith('en');
    const history = LEGAL_HISTORY[doc];
    if (!history) return null;

    const current = history.versions[0];

    if (archivedVersion) {
        const v = history.versions.find(x => x.version === archivedVersion);
        return (
            <Box bg="#FFF7ED" border="1px solid #FED7AA" borderRadius="14px" px="16px" py="12px" mb="24px">
                <Text fontSize="14px" color="#9A3412" fontWeight={600}>
                    {en
                        ? `Archived version ${v?.version} – effective ${v?.from}${v?.to ? ` to ${v.to}` : ''}. It is no longer in force.`
                        : `Wersja archiwalna ${v?.version} – obowiązywała od ${v?.from}${v?.to ? ` do ${v.to}` : ''}. Nie jest już obowiązująca.`}
                </Text>
                <Text as={RouterLink} to={current.path} fontSize="14px" color="#7A1F35" fontWeight={700} textDecoration="underline">
                    {en ? `Go to the current version ${current.version}` : `Przejdź do obowiązującej wersji ${current.version}`}
                </Text>
            </Box>
        );
    }

    const previous = history.versions.slice(1);
    return (
        <Flex gap="8px" flexWrap="wrap" fontSize="13px" color="#6E6064" mb="24px">
            <Text>{en ? 'Previous versions:' : 'Poprzednie wersje:'}</Text>
            {previous.length === 0
                ? <Text>{en ? 'none' : 'brak'}</Text>
                : previous.map(v => (
                    <Text key={v.version} as={RouterLink} to={v.path} color="#7A1F35" fontWeight={600} textDecoration="underline">
                        {`${v.version} (${v.from}–${v.to})`}
                    </Text>
                ))}
            <Text>·</Text>
            <Text as={RouterLink} to="/legal-archive" color="#7A1F35" fontWeight={600} textDecoration="underline">
                {en ? 'Document archive' : 'Archiwum dokumentów'}
            </Text>
        </Flex>
    );
};

export default LegalVersionNote;
